import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CachePolicies } from "use-http";

import { SubNavBar } from "components/common/SubNavBar";
import { AssesmentHistoryModal } from "components/heatmap/AssesmentHistoryModal/AssesmentHistoryModal";
import FiltersSection from "components/heatmap/FiltersSection/FiltersSection";
import { Heatmap } from "components/heatmap/HeatMap/HeatMap";
import { HeatmapSkeleton } from "components/heatmap/HeatMap/HeatmapSkeleton";
import { DETECTORS_SIZE, LABELERS_SIZE } from "components/heatmap/utils";
import { JANZU_URL } from "config/config";
import { useFetchCustom } from "hooks/useFetchCustom";
import { Typography } from "new-components/typography/Typography";
import { AssesmentsResponse } from "types/assesments";
import { removeEmptyValuesFromObject } from "utils/redirectDataPage";

export function LabelersManagement() {
  const [filters, setFilters] = useState<Record<string, string>>({
    detectors_search: "",
    labelers_search: "",
    detectors_sort: "WORST",
    labelers_sort: "WORST",
    detectors_size: DETECTORS_SIZE.toString(),
    labelers_size: LABELERS_SIZE.toString(),
  });
  const [currentData, setCurrentData] = useState<any | null>(null);
  const [openModal, setOpenModal] = useState(false);

  const assesmentsUrl = `${JANZU_URL}reef-api/assessments`;
  const {
    get: getListAssesments,
    data: listAssesments,
    loading: loadingListAssesments,
  } = useFetchCustom<AssesmentsResponse>(assesmentsUrl, { cachePolicy: CachePolicies.NO_CACHE });

  useEffect(() => {
    if (filters) {
      const queryString = new URLSearchParams(removeEmptyValuesFromObject(filters)).toString();
      getListAssesments(`?${queryString}`);
    }
  }, [filters, getListAssesments]);

  const handleClickCell = (data: any) => {
    setCurrentData(data);
    setOpenModal(true);
  };

  const onClose = () => {
    setCurrentData(null);
    setOpenModal(false);
  };

  return (
    <Box>
      <SubNavBar>
        <Typography variant="subtitle" textTransform="uppercase">
          Labelers Management
        </Typography>
      </SubNavBar>
      <Box
        id="labelers-management-container-temp"
        className="h-[calc(100%-50px)]"
        sx={{
          px: { xs: "10px", sm: "20px", md: "30px" },
          pb: "20px"
        }}>
        <FiltersSection filters={filters} setFilters={setFilters} />
        <Box className="mt-4 mb-2">
          {loadingListAssesments ? (
            <HeatmapSkeleton />
          ) : (
            <Heatmap data={listAssesments} filtersState={filters} onClickCell={handleClickCell} />
          )}
        </Box>
      </Box>

      {openModal && currentData && <AssesmentHistoryModal data={currentData} open={openModal} onClose={onClose} />}
    </Box>
  );
}
